interface ValidationIndicatorProps {
  isValid: boolean | null;
  captured: number | undefined;
  calculated: number | null;
  formatAmount: (amount: number | undefined) => string;
}

export function ValidationIndicator({
  isValid,
  captured,
  calculated,
  formatAmount,
}: ValidationIndicatorProps) {
  if (isValid === null) {
    return (
      <span className="text-gray-400" title="Cannot validate (missing data)">
        −
      </span>
    );
  }
  if (isValid) {
    return (
      <span className="text-emerald-500" title="Values match">
        ✓
      </span>
    );
  }
  const diff = (captured || 0) - (calculated || 0);
  const tooltip = `Expected: ${formatAmount(calculated ?? undefined)} (diff: ${diff >= 0 ? '+' : ''}${formatAmount(diff)})`;
  return (
    <span className="text-red-500" title={tooltip}>
      ✗
    </span>
  );
}
